export const getMessage = (intl, id, values?: any) => intl.formatMessage({ id }, values)
